import { GraphColorsPallete, GraphType } from "utils/enums/graph";

export const GRAPH_TYPE_LABELS: Record<GraphType, string> = {
  [GraphType.EnrolmentType]: "Student by Enrolment Type",
  [GraphType.Sector]: "Students Per Sector",
  [GraphType.SiteService]: "Staff Per Service",
};

export const GRAPH_TYPE_CATEGORY_LABELS: Record<GraphType, string> = {
  [GraphType.EnrolmentType]: "Select Enrolment Type",
  [GraphType.Sector]: "Select Sector",
  [GraphType.SiteService]: "Select Site/Service",
};

export const GRAPH_TYPE_CATEGORY_TABLE_HEADING: Record<GraphType, string> = {
  [GraphType.EnrolmentType]: "Enrolment Type",
  [GraphType.Sector]: "Sector",
  [GraphType.SiteService]: "Site/Service",
};

export const MAX_SELECTION_OF_GROUP = 5;

export const COLORS_LIST = [
  GraphColorsPallete.lightBlue,
  GraphColorsPallete.lightGreen,
  GraphColorsPallete.yellow,
  GraphColorsPallete.pink,
  GraphColorsPallete.purple,
  GraphColorsPallete.cyan,
  GraphColorsPallete.darkGreen,
  GraphColorsPallete.brown,
  GraphColorsPallete.olive,
];

export const REPORT_CSV_HEADER_PERCENTAGE = " (%)";
